
export function mixin(source, ctx: ClassDecoratorContext) {
    source.Mixin = function(dest, ctx: ClassDecoratorContext) {
        for(const p of Object.getOwnPropertyNames(source.prototype)) {
            if (p !== 'constructor')
                Object.defineProperty(dest.prototype, p, Object.getOwnPropertyDescriptor(source.prototype, p)!!);
        }
        for (const p of Object.getOwnPropertySymbols(source.prototype)) {
            Object.defineProperty(dest.prototype, p, Object.getOwnPropertyDescriptor(source.prototype, p)!!);
        }
    }
}
